import { object } from 'yup'
import { Step3SummaryForm } from '~app/screens/SpareAxleRequest/components/screens/step3/Step3SummaryForm'

export const Step3SummarySchema = object<Step3SummaryForm>({

}).defined()
